import { useCallback, useMemo, useState } from 'react';

export function useSearchInputState(initial: string = '') {
	const [searchValue, setSearchValue] = useState(initial);

	const reset = useCallback(() => setSearchValue(''), []);

	return useMemo(() => ({ value: searchValue, onChange: setSearchValue, reset }), [reset, searchValue]);
}
